import { buildReducer, PersonType } from '../../../shared';
import type {
    PendingActionsMap,
    PendingActionsState,
} from '../../state/view/groupsPendingActionsState';
import {
    favoriteGroupClickedAction,
    favoriteGroupCompletedAction,
    followGroupClickedAction,
    followGroupCompletedAction,
    unFavoriteGroupClickedAction,
    unFavoriteGroupCompletedAction,
    unFollowGroupClickedAction,
    unFollowGroupCompletedAction,
    leaveGroupConfirmClickedAction,
    dismissLeaveGroupDialogAction,
    leaveGroupCompletedAction,
    restoreGroupClickedAction,
    restoreGroupCompletedAction,
    renewGroupClickedAction,
    renewGroupCompletedAction,
    joinGroupClickedAction,
    joinGroupCompletedAction,
    notificationBarRestoreClickedAction,
    addFavoritePersonaCompletedAction,
    removeFavoritePersonaCompletedAction,
    addFavoritePersonaClickedAction,
    removeFavoritePersonaClickedAction,
    exportUnifiedGroupConfirmClickedAction,
    createExportUnifiedGroupTaskCompletedAction,
} from '../../../hub';

export const enum PendingActionTarget {
    Subscribe,
    Favorite,
    Leave,
    Join,
    Renew,
    Restore,
    Export,
}

export default buildReducer<PendingActionsMap>()
    .handle(favoriteGroupClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Favorite
        );
    })
    .handle(addFavoritePersonaClickedAction, (state, action) => {
        if (action.payload.favorite.type === PersonType.FavoriteUnifiedGroup) {
            return updateActionState(
                state,
                action.payload.favorite.hubPersonaId,
                true,
                PendingActionTarget.Favorite
            );
        }
        return state;
    })
    .handleDataAction(
        favoriteGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Favorite
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Favorite
            );
        }
    )
    .handleDataAction(
        addFavoritePersonaCompletedAction,
        (state, action) => {
            if (state[action.payload.hubPersonaId]) {
                return updateActionState(
                    state,
                    action.payload.hubPersonaId,
                    false,
                    PendingActionTarget.Favorite
                );
            }
            return state;
        },
        (state, action) => {
            if (state[action.payload.hubPersonaId]) {
                return updateActionState(
                    state,
                    action.payload.hubPersonaId,
                    false,
                    PendingActionTarget.Favorite
                );
            }
            return state;
        }
    )
    .handle(followGroupClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Subscribe
        );
    })
    .handleDataAction(
        followGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Subscribe
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Subscribe
            );
        }
    )
    .handle(unFavoriteGroupClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Favorite
        );
    })
    .handle(removeFavoritePersonaClickedAction, (state, action) => {
        if (action.payload.isGroup) {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                true,
                PendingActionTarget.Favorite
            );
        }
        return state;
    })
    .handleDataAction(
        unFavoriteGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Favorite
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Favorite
            );
        }
    )
    .handleDataAction(
        removeFavoritePersonaCompletedAction,
        (state, action) => {
            if (state[action.payload.hubPersonaId]) {
                return updateActionState(
                    state,
                    action.payload.hubPersonaId,
                    false,
                    PendingActionTarget.Favorite
                );
            }
            return state;
        },
        (state, action) => {
            if (state[action.payload.hubPersonaId]) {
                return updateActionState(
                    state,
                    action.payload.hubPersonaId,
                    false,
                    PendingActionTarget.Favorite
                );
            }
            return state;
        }
    )
    .handle(joinGroupClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.group.hubPersonaId,
            true,
            PendingActionTarget.Join
        );
    })
    .handleDataAction(
        joinGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.group.hubPersonaId,
                false,
                PendingActionTarget.Join
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Join
            );
        }
    )
    .handle(unFollowGroupClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Subscribe
        );
    })
    .handleDataAction(
        unFollowGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Subscribe
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Subscribe
            );
        }
    )
    .handle(leaveGroupConfirmClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Leave
        );
    })
    .handle(dismissLeaveGroupDialogAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            false,
            PendingActionTarget.Leave
        );
    })
    .handleDataAction(
        leaveGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Leave
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Leave
            );
        }
    )
    .handle(restoreGroupClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Restore
        );
    })
    .handle(notificationBarRestoreClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Restore
        );
    })
    .handleDataAction(
        restoreGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Restore
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Restore
            );
        }
    )
    .handle(renewGroupClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Renew
        );
    })
    .handle(exportUnifiedGroupConfirmClickedAction, (state, action) => {
        return updateActionState(
            state,
            action.payload.hubPersonaId,
            true,
            PendingActionTarget.Export
        );
    })
    .handleDataAction(
        renewGroupCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Renew
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Renew
            );
        }
    )
    .handleDataAction(
        createExportUnifiedGroupTaskCompletedAction,
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Export
            );
        },
        (state, action) => {
            return updateActionState(
                state,
                action.payload.hubPersonaId,
                false,
                PendingActionTarget.Export
            );
        }
    )
    .done({});

function updateActionState(
    originalMap: { [groupId: string]: PendingActionsState },
    groupId: string,
    newState: boolean,
    target: PendingActionTarget
): { [groupId: string]: PendingActionsState } {
    const updatedGroupsMap = { ...originalMap };
    let newActionState: PendingActionsState;
    if (originalMap[groupId]) {
        newActionState = updatedGroupsMap[groupId];
    } else {
        newActionState = {
            isSubscribeActionPending: false,
            isFavoriteActionPending: false,
            isLeaveActionPending: false,
            isJoinActionPending: false,
            isRestoreActionPending: false,
            isRenewActionPending: false,
            isExportActionPending: false,
        };
    }
    switch (target) {
        case PendingActionTarget.Favorite:
            newActionState = {
                ...newActionState,
                isFavoriteActionPending: newState,
            };
            break;
        case PendingActionTarget.Join:
            newActionState = {
                ...newActionState,
                isJoinActionPending: newState,
            };
            break;
        case PendingActionTarget.Leave:
            newActionState = {
                ...newActionState,
                isLeaveActionPending: newState,
            };
            break;
        case PendingActionTarget.Renew:
            newActionState = {
                ...newActionState,
                isRenewActionPending: newState,
            };
            break;
        case PendingActionTarget.Restore:
            newActionState = {
                ...newActionState,
                isRestoreActionPending: newState,
            };
            break;
        case PendingActionTarget.Subscribe:
            newActionState = {
                ...newActionState,
                isSubscribeActionPending: newState,
            };
            break;
        case PendingActionTarget.Export:
            newActionState = {
                ...newActionState,
                isExportActionPending: newState,
            };
            break;
        default:
    }
    updatedGroupsMap[groupId] = newActionState;
    return updatedGroupsMap;
}
export type { Action } from '../../../shared';
